<template>
  <div class="privacy-statement">
    <HeaderComponent screenName="" />
    <ContractVehiclesBannerComponent
      imageSrc="contracts-banner.jpg"
      heading="Privacy Statement"
    />
    <div class="section-div" data-aos="fade-up">
     <div class="cards-container">   
      <div class="card" data-aos="fade-up">
        <p>
       G14C values its relationship with visitors to this website and believes in safeguarding their privacy. Therefore, you can generally browse this site without providing any personal information. Nevertheless, there are circumstances where we may need information from you, for instance to process a request for a product or service, to gather valuable feedback, or to communicate in connection with a job application.<br><br>

       G14C does not sell, rent or lease personal information to third parties. In order to help provide our services, we occasionally provide information to other companies that work on our behalf.<br><br>
       </p>
        <p class="subheading">Use of Cookies</p>
        <p>
          This website may collect non-identifiable information through the use of technologies, such as "cookies". A cookie is a piece of data that a website can send to your browser, which may then be stored on your computer as an anonymous tag that identifies your computer but not you. You can set your browser to notify you before you receive a cookie, giving you the chance to decide whether to accept it. You can also set your browser to turn off cookies. If you do so, however, some parts of the Web sites may not work properly.<br><br>

          G14C uses non-identifiable information to keep track of your interactions with our sites and to offer a personalized experience. We aggregate this data to provide feedback to our web designers, content providers or business managers to assist them in improving our web site and the services offered. Cookies are also used to automatically fill forms so that you do not need to re-enter data, for example, when you apply for a job online or request for information.<br><br>

        </p>
        <p class="subheading">Links to non-G14C Websites</p>
        <p>
        This website may contain links to other sites. However, G14C takes no responsibility for the product, services, privacy policies or contents of those other websites. We encourage you to be aware when you are leaving our site and to read the privacy policies of each Web site you visit.<br><br>
       </p>
       <p class="subheading">Notification of Changes</p>
       <p>
        G14C reserves the right to change this privacy policy without notice and will post any revisions on the website.<br><br>
        For any queries about this Privacy Policy, please e-mail us at 
       </p>
      </div>
    </div>
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import ContractVehiclesBannerComponent from '@/components/contract vehicles/ContractVehiclesBannerComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    ContractVehiclesBannerComponent,
    FooterComponent,
  },
});
</script>

<style scoped>
.section-div {
  background-color: #f2f2f2;
  padding-left: 110px;
  padding-right: 110px;
  padding-top: 100px;
  padding-bottom: 50px;
}

.cards-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 55px; 
}

.card {
  background-color: #fff;
  padding: 50px;
  width: 85%; 
  height: auto;
  text-align: left;
  font-family: Roboto;
  box-shadow:  0 8px 16px rgba(0, 0, 0, 0.2); 
  font-size: 20px; 
}
.subheading
{
  text-align: center;
  font-family: Roboto;
  font-size:23px;
  font-weight: 400;
  
}
</style>
